import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class PowerBiService {
  private apiUrl = environment.apiUrl;
  powerBiUrl = `${this.apiUrl}public/links/`;
  configLinksUrl = `${this.apiUrl}sistema/empresas/lojas/links`;

  constructor(private _http: HttpClient) {
  }

  getPowerBi(params): Observable<{}> {
    return this._http.get(this.powerBiUrl + params.lojaId + '/' + params.tipo)
      .pipe(map(data => {
        return data;
      }));
  }

  getPowerBiEmpresa(params): Observable<any[]> {
    return this._http.get(`${this.configLinksUrl}/${params.empresaId}/${params.loja}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertLink(link): Observable<{}> {
    return this._http.post(this.configLinksUrl, link)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
